// fade-in-on-view.js
(function () {
    function register(Alpine) {
        if (Alpine.__fadeInOnViewRegistered) return;
        Alpine.__fadeInOnViewRegistered = true;

        Alpine.data('fadeInOnView', (opts = {}) => ({
            // Defaults (so fadeInOnView() just works)
            direction: 'bottom',
            distance: 48,
            duration: 600,
            visible: false,
            delay: 0,
            once: true,

            // Internals
            _observer: null,
            _hasRun: false,
            _reduced: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false,

            init() {
                Object.assign(this, opts);
                this._applyInitialStyles();   // no transitions yet
                this._observeFor20px();
            },

            _observeFor20px() {
                this._observer = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (!entry.isIntersecting) continue;
                        const r = entry.intersectionRect;
                        if (r && r.width >= 20 && r.height >= 20) {
                            if (this.once) this._observer.disconnect();
                            this._start();
                            break;
                        }
                    }
                }, { threshold: [0, 0.01, 0.1, 0.25, 0.5, 1] });
                this._observer.observe(this.$root);
            },

            _applyInitialStyles() {
                const el = this.$root;
                const [tx, ty] = this._vectorFromDirection(this.direction, this.distance);

                if (this._reduced) {
                    el.style.opacity = '1';
                    el.style.transform = 'none';
                    return;
                }

                // Initial pose WITHOUT transitions (first paint commits hidden state)
                el.style.opacity = '0';
                el.style.transform = `translate(${tx}px, ${ty}px)`;
                el.style.transitionProperty = 'none';
                el.style.willChange = 'opacity, transform';
            },

            _start() {
                if (this._hasRun && this.once) return;
                this._hasRun = true;
                this.visible = true;

                const el = this.$root;

                if (this._reduced) {
                    el.style.opacity = '1';
                    el.style.transform = 'none';
                    return;
                }

                // Double RAF to avoid transition “jump”
                requestAnimationFrame(() => {
                    el.style.transitionProperty = 'opacity, transform';
                    el.style.transitionDuration = `${this.duration}ms`;
                    el.style.transitionTimingFunction = 'cubic-bezier(.22,.61,.36,1)';
                    el.style.transitionDelay = `${this.delay}ms`;

                    requestAnimationFrame(() => {
                        el.style.opacity = '1';
                        el.style.transform = 'translate(0, 0)';

                        if (this.once) {
                            const total = this.duration + this.delay + 50;
                            setTimeout(() => { el.style.willChange = ''; }, total);
                        }
                    });
                });
            },

            _vectorFromDirection(dir, d) {
                switch ((dir || '').toLowerCase()) {
                    case 'top':    return [0, -d];
                    case 'bottom': return [0,  d];
                    case 'left':   return [-d, 0];
                    case 'right':  return [ d, 0];
                    case 'none':   return [0, 0];
                    default:       return [0, d];
                }
            }
        }));
    }

    // Register now if Alpine exists; otherwise wait for 'alpine:init'
    if (window.Alpine) {
        register(window.Alpine);
    } else {
        document.addEventListener('alpine:init', () => register(window.Alpine));
    }
})();
